import {styled} from "@mui/material";

export const Wrapper = styled('div')(
  {
    display: 'flex',
    flexDirection: 'column',
  },
  ({ withNavBar }) => withNavBar
    ? {
      height: '100vh',
      overflow: 'hidden',
    }
    : {
      minHeight: '100vh',
    }
);

export const MainPane = styled('div')(
  {
    flex: 1,
    minHeight: 0,
  },
  ({ theme, withNavBar }) =>
    withNavBar && {
      overflow: 'auto',
    }
);
